import { Info, User } from '@azing/user';
import { combineLatest, fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import { AzingUserService } from './azing-user.service';
import { signedInEl } from './templates/signed-in-el';
import { signedOutEl } from './templates/signed-out-el';

const azingUserService = new AzingUserService();

export const createUserMenu$ = combineLatest(
  fromEvent(window, 'load'),
  azingUserService.azing.current$,
  azingUserService.azing.info$,
).pipe(
  map(([, user, info]) => createUserMenu(user, info)),
);

export function createUserMenu(user: User, info: Info): boolean {
  const navUser = document.querySelector('.nav-user');

  if (!navUser) return false;

  if (user.id === -1) {
    navUser.innerHTML = '';
    navUser.appendChild(signedOutEl());
  } else {
    navUser.innerHTML = '';
    navUser.appendChild(signedInEl(user, info));
  }
  return true;
}

(() => {
  createUserMenu$.subscribe();
})();
